import { Consultant } from 'models/common'
import 'models/pagination'
import { PaginationParams, PaginationResponse } from 'models/pagination'

export const MBonusStatus = {
  in_process: 'in_process',
  waiting: 'waiting',
  error: 'error',
  ready: 'ready',
  denied: 'denied',
} as const

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type MBonusStatus = (typeof MBonusStatus)[keyof typeof MBonusStatus]

type Comment = {
  id: number
  text: string
  created_at: string
}
export type MBonusObject = {
  id: string
  jira_key: string
  inn: string
  name: string
  get_full_address: string
  status: MBonusStatus
  consultant_name: string
  cashback: string
  field_activity?: {
    id: number
    name: string
  }
  created_at: string
  attached_file: string
  payment_method: {
    id: number
    name: string
  }
  phone: string
  commercial_name: string
  count_points: string
  comments: Comment[]
  consultant: Consultant
  description: string
  transitions: string
  city: string
  address: string
  type: string
}

export type MBonusShortObject = {
  id: string
  jira_key: string
  inn: string
  name: string
  get_full_address: string
  status: MBonusStatus
  consultant_name: string
  cashback: string
  count_points: string
  field_activity?: {
    id: number
    name: string
  }
  created_at: string
}

export type GetMBonusListResponse = PaginationResponse<MBonusShortObject>

export interface GetMBonusParams extends PaginationParams {
  search?: string
  status?: string
  start_date?: string
  end_date?: string
  consultant?: string
  supervisor?: string
  jira_key?: string
  branch_type?: string
  cashback?: string
  field_activity?: string
  branch?: number
}
